export const arrayBufferToFile = (buffer: Uint8Array, fileName: string, type: string = 'application/pdf'): File => {
    const blob = new Blob([buffer], { type });
    const file: File = new File([blob], fileName, { type });
    return file;
}

export const blobToFile = (blob: Blob, fileName: string, type?: string): File => {
    return new File([blob], fileName, { type: type || blob.type });
}